import axios from "axios";
import { AES, enc } from 'crypto-js';
import { toast } from "react-toastify";
import { DateRangePicker } from "rsuite";
import CalendarIcon from '../../../ui/CalendarIcon';
import { useNavigate, useParams } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { ResizeObserver } from 'resize-observer';
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect, useRef } from "react";
import { logout, reset } from "../../../../features/auth/authSlice";
import userTypeConsts from "../../../../constants/userTypeConsts.js";
import { reset as invoiceReset } from "../../../../features/invoice/invoiceSlice.js";
import { setClientInvoiceData } from "../../../../features/client/clientInvoiceSlice.js";
import { reset as headerReset } from "../../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../../features/appSettings/appSettingsSlice.js";

const ClientInvoiceModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { encryptedId } = useParams();
  const decodedId = decodeURIComponent(encryptedId.replace(/%2F/g, '/'));
  const decryptedBytes = AES.decrypt(decodedId, 'encryptionKey');
  const id = decryptedBytes.toString(enc.Utf8);
  const [errorMessage, setErrorMessage] = useState({ message: null, field: null });
  const { appSettings } = useSelector((state) => state.appSettings);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);

  let token = null;
  const user = useSelector(
    (state) => state.auth.user
  )
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }

  const handleSelect = (ranges) => {
    setDateRange(ranges);
    setErrorMessage({ message: null, field: null });
  };
  const SUPER_ADMIN = 1;
  const ADMIN = 2;
  const ref = useRef(null);
  let resizeObserver = null;

  useEffect(() => {
    // Create a new ResizeObserver instance
    resizeObserver = new ResizeObserver(entries => {
      // Handle resize event
    });

    if (ref.current) {
      // Observe the target element
      resizeObserver.observe(ref.current);
    }

    // Cleanup function
    return () => {
      if (resizeObserver) {
        // Disconnect the observer when component unmounts
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    };
  }, []);

  const clientInvoiceSubmit = async () => {
    var autoData = [];

    if (dateRange === null) {
      toast.error("Please select date", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    } else if (dateRange[0] === dateRange[1]) {
      toast.error("Please select date", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    } else if (dateRange[0].getTime() === dateRange[1].getTime()) {
      toast.error("Please select different date", {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    } else {
      // Convert Date objects to ISO strings for Redux serialization
      const serializedDateRange = dateRange.map(date => date instanceof Date ? date.toISOString() : date);
      autoData.push(serializedDateRange);
      autoData.push(id);
      await dispatch(setClientInvoiceData(autoData));
      navigate(`/client/invoices/create/${encodeURIComponent(AES.encrypt(id, 'encryptionKey').toString().replace(/\//g, '%2F'))}`);
    }
  };

  return (
    <div className="invoice-modal" ref={ref}>
      <h2 className="invoice-modal-main-head">Create Invoice</h2>

      <div className="form-group-1modal range-picinmodal-1">
        <label htmlFor="date-range">Date Range *</label>

        <div className="date-picker-outer date-picker-outer-all">
          <div className="custoom-icon-calender custoom-icon-calender-all">
            <DateRangePicker
              showOneCalendar
              className={errorMessage && errorMessage.field === 'both' ? "errorDate" : ""}
              id="date-range"
              format="dd/MM/yyyy"
              character="   to   "
              placeholder="Select a date range"
              value={dateRange}
              onChange={handleSelect}
              placement="auto"
              isoWeek={appSettings.weekStartDay === 'Monday'}
              caretAs={CalendarIcon}
            />
          </div>
        </div>

      </div>
      <div className="form-group-1modal submittseloutter-1">
        <button className="create-button modalsubmitbtn-1" onClick={clientInvoiceSubmit}>
          Create Invoice
        </button>
      </div>
    </div>
  );
};

export default ClientInvoiceModal;